import { render, staticRenderFns } from "./VideoPromoModal.vue?vue&type=template&id=64b7552a"
import script from "./VideoPromoModal.vue?vue&type=script&lang=js"
export * from "./VideoPromoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports